
const digest = '69c84e3438fe9835a6ec4de0d8c3e1c09a09cb3d7f0716ee2e5521f12daa71db';
const classes = {"hint":"_hint_1wppm_1"};
const css = `._hint_1wppm_1 {
  font-size: 12px;
  margin-top: 10px;
  font-weight: 600;
  color: #3e3f42;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  